import ReactPlayer from 'react-player/lazy';
import {
    useVideoAttachmentContentActions,
} from '../../../resource/resources/artifacts/attachment/videoAttachmentContentResource';

export const VideoContentDisplay= ({videoAttachmentId, height}: {
    videoAttachmentId: string | undefined;

    height: number | null | undefined;
}) => {
    const videoAttachmentContentActions = useVideoAttachmentContentActions()


    const videoAttachmentContentQuery =  videoAttachmentContentActions.useGetSingleResource(videoAttachmentId)

    const getExtension = () => {
        const split = videoAttachmentContentQuery.data?.fileName?.split(".")
        if (!split) {
            return ""
        }
        const splitLength = split.length
        return split[splitLength - 1]
    }





    if (videoAttachmentContentQuery.data) {
        return <ReactPlayer width={'100%'} height={height ?? undefined} url={`data:video/${getExtension()};base64,${videoAttachmentContentQuery.data.fileContent}`} controls />
    } else if (videoAttachmentContentQuery.isLoading) {
        return <div style={{
            height: height ?? undefined,
            width: "100%",
            backgroundColor: "grey",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <span style={{fontWeight: "bold"}}>Video is being loaded ...</span>
        </div>;
    }

    return <div style={{
        height: height ?? undefined,
        width: "100%",
        backgroundColor: "grey",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }}>
        <span style={{fontWeight: "bold"}}>No video content has been found!</span>
    </div>
};
